import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const FLOUR_SACK = "#ece3d2";
const FLOUR_TIE = "#bcae97";

function sackUnit(cx: number, cy: number, cz: number, s: number): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: FLOUR_SACK, position: [cx, cy, cz], scale: [1, 0.92, 0.82] as const },
    { geometry: new THREE.CylinderGeometry(s * 0.34, s * 0.46, s * 0.3, 6), color: FLOUR_TIE, position: [cx, cy + s * 0.62, cz] },
  ];
}

export const flourSack = defineModel({
  id: "flour-sack",
  batchId: "characters",
  name: "Flour sack",
  tags: ["good", "cargo", "food"],
  fits: ["carry"],
  summary: "A pale flour sack -- a carriable good for an avatar's carry socket.",
  description:
    "A single pale flour sack at held scale, ported from age-of-mcp's goods " +
    "(`flour`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling flour.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => sackUnit(0, 0.05, 0.02, 0.075),
  animations: [],
});
